import { render, staticRenderFns } from "./PaperInfo.vue?vue&type=template&id=7b86c7e8&scoped=true&"
import script from "./PaperInfo.vue?vue&type=script&lang=js&"
export * from "./PaperInfo.vue?vue&type=script&lang=js&"
import style0 from "./PaperInfo.vue?vue&type=style&index=0&id=7b86c7e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b86c7e8",
  null
  
)

export default component.exports